import { Box, Text } from "@chakra-ui/react";

const TEST_ORDER_COLOR = "#DD6B20";

const TestOrderBadge: React.FC = () => (
  <Box
    className="test-order-badge"
    position="absolute"
    top="-18px"
    left="16px"
    zIndex={5}
    pointerEvents="none"
  >
    <Box
      position="absolute"
      bottom="-4px"
      left="10px"
      width={0}
      height={0}
      borderLeft="4px solid transparent"
      borderRight="4px solid transparent"
      borderTop={`4px solid ${TEST_ORDER_COLOR}`}
    />
    <Box
      bg={TEST_ORDER_COLOR}
      color="white"
      px={2}
      py={0.5}
      borderRadius="md"
      boxShadow="sm"
      display="flex"
      alignItems="center"
      whiteSpace="nowrap"
    >
      <Text fontSize="10px" fontWeight="800" letterSpacing="0.08em">
        🧪 TEST ORDER
      </Text>
    </Box>
  </Box>
);

export { TEST_ORDER_COLOR };
export default TestOrderBadge;
